import React, {useState, useContext} from "react";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { AppContext } from "../../App";

export default function Clause(props){

  const { activeUser, setChangesMade } = useContext(AppContext)

  const contrClauses = activeUser.contractClauses

  const [editable, setEditable] = useState(true)

  const [textValue, setTextValue] = useState(contrClauses[props.index])

  function toggleEdit(){
  setEditable(prev=>!prev)
  }

  function getTextValue(e, index){
    setTextValue({...contrClauses[index],
      heading: contrClauses[index].heading,
      content: e.target.value
    })
  }

  async function updateClause(e){
    e.preventDefault()
    const updatedClause = {...textValue}
    const user = localStorage.getItem("user")

    await fetch(`https://the-paper-pusher.herokuapp.com/updateClause/${user}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(updatedClause)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    setChangesMade(prev => prev+1)
    toggleEdit()
  }

  return(
    <div className="clause-text-area">
      <TextField
          key={props.index}
          name="content"
          variant="filled"
          multiline
          defaultValue={props.defValue}
          sx={{minWidth: 280, border: "none"}}
          onChange={(e) => getTextValue(e, props.index)}
          disabled={editable}
      />
      <div className="clause-btns">
        <Button onClick={toggleEdit} sx={{fontSize: '1.2em'}} hidden={!editable}>edit</Button>
        <Button hidden={editable} name="btn" onClick={updateClause} sx={{fontSize: '1.2em', color: 'red'}}>Save</Button>
        <Button onClick={props.delFunc} sx={{fontSize: '1.2em', color: '#56132a'}}>Delete</Button>
      </div>
    </div>
  )

}